module.exports = __webpack_public_path__ + "static/img/cont42_03.e77dff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont42_03.png
// module id = YXVM
// module chunks = 0